import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import Button from 'common/components/Button';
import { TranslatedMessage } from 'common/components/Intl';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as Messages from 'apps/calculator/messages';
import { useHTML5FormValidation } from 'common/hooks/use-html5-form-validation';

export default function CalculatorForm({
  currencySymbol,
  defaultCigarettesPerDay = 0,
  defaultPricePerPack = 0,
  onSubmit,
}) {
  const submitCallback = values => {
    onSubmit({
      price_per_pack: values.price_per_pack,
      cigarettes_per_day: values.cigarettes_per_day,
    });
  };

  const { values, errors, handleChange, handleSubmit } = useHTML5FormValidation(
    {
      defaultValues: {
        price_per_pack: defaultPricePerPack,
        cigarettes_per_day: defaultCigarettesPerDay,
      },
      submitCallback,
    }
  );

  return (
    <>
      <h2 className="calculator-form__title heading--title--small">
        <TranslatedMessage id={Messages.FORM_TELL_US_ABOUT_YOU} />
      </h2>
      <div className="calculator-form__separator" />
      <form onSubmit={handleSubmit} className="Form" noValidate>
        <label htmlFor="price_per_pack">
          <TranslatedMessage id={Messages.FORM_HOW_MUCH_PER_PACK} />
        </label>
        <div className="calculator-form__input">
          <input
            className="Field__input"
            name="price_per_pack"
            onChange={handleChange}
            type="number"
            placeholder={currencySymbol}
            required
            value={values.price_per_pack}
          />
          {errors.price_per_pack && (
            <div className="Field__error">{errors.price_per_pack}</div>
          )}
        </div>
        <label htmlFor="cigarettes_per_day">
          <TranslatedMessage id={Messages.FORM_HOW_MANY_PER_DAY} />
        </label>
        <div className="calculator-form__input">
          <input
            className="Field__input"
            name="cigarettes_per_day"
            onChange={handleChange}
            type="number"
            placeholder="#"
            value={values.cigarettes_per_day}
            required
          />
          {errors.cigarettes_per_day && (
            <div className="Field__error">{errors.cigarettes_per_day}</div>
          )}
        </div>
        <Button className={classNames('Form__submit-button')} type="submit">
          <TranslatedMessage id={Messages.FORM_CALCULATE} />
        </Button>
      </form>
    </>
  );
}

CalculatorForm.propTypes = {
  onSubmit: propTypes.func.isRequired,
};
